import { render, staticRenderFns } from "./AffirmAuthorsDetails.vue?vue&type=template&id=15b51f56&"
import script from "./AffirmAuthorsDetails.vue?vue&type=script&lang=js&"
export * from "./AffirmAuthorsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports